import React, { Fragment, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { bool, shape } from "prop-types";
import { push } from "connected-react-router";
import { useLocation, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";
import * as i18n from "util/i18n";
import { transactionStatus } from "pages/transactions/constants";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import Notification from "pages/_components/Notification";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Button from "pages/_components/Button";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { actions as sessionActions, selectors as sessionSelectors } from "reducers/session";
import Avatar from "pages/_components/Avatar";

import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";
// eslint-disable-next-line import/no-named-as-default
import ResponsiveHeader from "pages/_components/header";

const CashOutTransactionPage = ({ isDesktop, transaction, cashOutSendStatus }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const dispatch = useDispatch();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const [showToken, setShowToken] = useState(false);
    const [buttonLabel, setButtonLabel] = useState(
        isDesktop ? "eunsecured.loan.seeMore.ticket.button" : "unsecured.loan.seeLess.ticket.button",
    );
    const isBackoffice = pathname.includes("backoffice");
    const isLoading = !transaction || !transaction?.data;

    const getAccountLabel = () =>
        `****${transaction?.data?.odeData?.accountNumber?.slice(-4)} ${i18n.get(`client.productType.short.${transaction?.data?.odeData?.accountType}`)} ${i18n.get(
            `currency.label.${transaction?.data?.odeData?.accountCurrency}`,
        )}`;

    const { user } = useSelector((_state) => _state.session);

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const transactionData = {
        accountLabel: getAccountLabel() || "",
        amount: transaction?.data?.odeData?.amount || "",
        fullname: `${transaction?.data?.odeData?.nombre} ${transaction?.data?.odeData?.apellido}`,
        documentNumber: transaction?.data?.odeData?.documentNumber || "",
        phoneNumber: `+${transaction?.data?.odeData?.phoneNumber}` || "",
        company: transaction?.data?.company,
        obfuscatedODEnumber: transaction?.data?.obfuscatedODEnumber,
        reference: transaction?.data?.odeData?.reference,
    };

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
              transaction.idTransactionStatus === transactionStatus.CANCELLED
            ? "tag-error"
            : "tag-warning";

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id]);

    useEffect(() => {
        if (!transaction?.data?.odeData && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [transaction]);

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("unsecured.loan.seeLess.ticket.button");
        } else {
            setButtonLabel("unsecured.loan.seeMore.ticket.button");
        }
    };

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "activities.cashout.send",
        id,
        "cash.out.trasaction",
    );

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    const requestBody = {
        idTransaction: id,
        odeData: {
            accountNumber: transaction?.data?.odeData?.accountNumber,
            accountProductId: transaction?.data?.odeData?.accountProductId,
            amount: transactionData.amount,
            phoneNumber: transaction?.data?.odeData?.phoneNumber,
            nombre: transaction?.data?.odeData?.nombre,
            apellido: transaction?.data?.odeData?.apellido,
            documentNumber: transactionData.documentNumber,
            reference: transactionData.odeData?.reference,
        },
    };

    // eslint-disable-next-line no-confusing-arrow
    const sign = () =>
        !showToken ? (
            <Col xs={12} md={4}>
                <CustomButton
                    func={() => setShowToken(true)}
                    text="forms.signTransaction.link"
                    textType="I18N"
                    className="btn btn-primary"
                />
            </Col>
        ) : (
            <GeneralCredentialForm
                transactionData={requestBody}
                type="otp"
                action={accountsActions.cashOutSend}
                idActivity="cashout.send"
                hideIndications
            />
        );

    const transactionStatusID = () => {
        let statusId;
        switch (transaction?.idTransactionStatus) {
            case transactionStatus.PENDING:
                statusId = transactionStatus.PENDING;
                break;
            case transactionStatus.FINISHED:
                statusId = "APPROVED";
                break;
            default:
                statusId = "REJECTED";
                break;
        }
        return statusId;
    };

    return (
        <Fragment>
            <Notification scopeToShow="cash.out.trasaction" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle={i18n.get("", "Extracción de efectivo")} />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title="menu.cashout"
                                subTitle={`cashout.transaction.status.${transactionStatusID()}`}
                                isDesktop
                            />
                            <div className="ticket cashout">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body ticket__full-width two-columns">
                                        <div>
                                        <div className="ticket-header-info">
                                                <div className="beneficiary">
                                                    <div className="avatar-name">
                                                        <Avatar
                                                            user={{
                                                                userFullName: `${transactionData?.company}` || "",
                                                                defaultAvatarId: "0",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="user-info">
                                                    <CustomData
                                                        className="align-items-center"
                                                        titleText={i18n.get("", "Empresa")}
                                                        titleTextType="TEXT"
                                                        valueTextType="TEXT"
                                                        valueText={transactionData?.company}
                                                    />
                                                    </div>
                                                </div>
                                            </div>
                                       </div>
                                        <div>
                                            <CustomData
                                                dataClass={`align-items-center amount tag ${tagType}`}
                                                titleText={i18n.get("", "Monto")}
                                                titleTextType="TEXT"
                                                valueTextType="TEXT"
                                                valueText={
                                                    <FormattedAmount currency="ARS" quantity={transactionData.amount} />
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="ticket__body ticket__full-width">
                                        <div className="view-more-data-button">
                                            <div className="ticket__divider signatures-divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left" />
                                                <div className="ticket__notch ticket__notch--right" />
                                            </div>{" "}
                                            <Button
                                                aria-expanded={showMoreData ? "true" : "false"}
                                                className="more-button"
                                                label={buttonLabel}
                                                bsStyle="link"
                                                onClick={handleSeeMoreData}
                                                defaultLabelText="Ver más detalle"
                                                image={
                                                    showMoreData
                                                        ? "figma/icon/arrow-up.svg"
                                                        : "figma/icon/arrow-down.svg"
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className={`${showMoreData ? "expand " : "collapse"}`}>
                                        <div className="ticket__body ticket__full-width">
                                            <GridTable>
                                                <GridTable.Container columnsTemplate="2fr 1fr">
                                                    <GridTable.Data>
                                                    &nbsp;
                                                    </GridTable.Data>      
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>     
                                                    <GridTable.Data className="origin-account">
                                                        <TransactionInfo
                                                            fieldString="Cuenta origen"
                                                            value={transactionData.accountLabel}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data className="phone-number">
                                                        <TransactionInfo
                                                            fieldString="Celular"
                                                            value={transactionData.phoneNumber}
                                                        />
                                                    </GridTable.Data>  
                                                    <GridTable.Data>
                                                    &nbsp;
                                                    </GridTable.Data>      
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>     
                                                    <GridTable.Data className="name">
                                                        <TransactionInfo
                                                            fieldString="Nombre"
                                                            value={transaction?.data?.odeData?.nombre}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data className="name">
                                                        <TransactionInfo
                                                            fieldString="Apellido"
                                                            value={transaction?.data?.odeData?.apellido}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data>
                                                    &nbsp;
                                                    </GridTable.Data>      
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>   
                                                    <GridTable.Data className="document-number">
                                                        <TransactionInfo
                                                            fieldString="DNI"
                                                            value={transactionData.documentNumber}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data className="phone-number">
                                                        <TransactionInfo
                                                            fieldString="Referencia"
                                                            value={transactionData.reference}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data>
                                                    &nbsp;
                                                    </GridTable.Data>      
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>   
                                                </GridTable.Container>
                                            </GridTable>
                                        </div>
                                        <div className="ticket__body ticket__full-width">
                                            {transaction.idTransactionStatus === transactionStatus.PENDING ? (
                                                <TransactionSign
                                                    isDesktop={isDesktop}
                                                    noDate
                                                    creationTime
                                                    isSmall
                                                    showMoreData={showMoreData}
                                                    hasVoucherInPending
                                                    hasVaucher  
                                                />
                                            ) : (
                                                <TransactionSign
                                                    isDesktop={isDesktop}
                                                    hasVaucher
                                                    showMoreData={showMoreData}
                                                    showSignatures
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <Row className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                </div>

                {!isBackoffice && (
                    <Row className="form-actions">
                        {transaction?.data?.idTransactionStatus !== "FAILED" ? (
                            <>
                               <Col xs={12} md={4} mdOffset={2}>
                                    {(!showToken || cashOutSendStatus!=null) && (
                                    <CustomButton
                                        func={() => dispatch(push("/desktop"))}
                                        text="forms.transaction.ticket.actions.backToHome"
                                        textType="I18N"
                                        className="btn btn-outline"
                                    />
                                    )}
                                </Col>
                                {!showSignButton ? (
                                    
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-primary"
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            onClick={handleDownload}
                                        />
                                    </Col>
                                ) : (
                                    sign()
                                )}
                                {!showSignButton && !isDesktop && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/share.svg"
                                            label="global.share"
                                            onClick={() => {
                                                handleShareMobile();
                                            }}
                                        />
                                    </Col>
                                )}
                            </>
                        ) : (
                            <Col xs={12} md={4} mdOffset={4}>
                                <CustomButton
                                    func={() => {}}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </Fragment>
    );
};

CashOutTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
    transaction: shape({}).isRequired,
};

const mapStateToProps = (state) => ({
    fetching: accountsSelectors.getFetching(state),
    transaction: formSelectors.getTransaction(state),
    generateCashOutCodeInProgress: accountsSelectors.getGenerateCashOutCodeInProgress(state),
    cashOutSendStatus: accountsSelectors.getCashOutSendStatus(state),
});

export default connect(mapStateToProps)(CashOutTransactionPage);
